import { Icon } from '../../../components/icons/Icon';
import { SEVERITY_CONFIG, type Severity } from '../../../utils';

/**
 * Internal severity icon for ValidationBanner rows. Always renders an icon —
 * caller guarantees a known severity. For the public, fault-tolerant variant
 * (with tooltip / null severity support) use `<ValidationSeverityIcon />`.
 */
export function SeverityIcon({ severity, className }: { severity: Severity; className?: string }) {
  const cfg = SEVERITY_CONFIG[severity];
  return <Icon name={cfg.icon} className={`${cfg.iconColor} ${className ?? ''}`} />;
}
